import { Box, CssBaseline, Link, Typography, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import { ConferenceContext } from '@/store';

const useStyles = () => ({
  coeoLogo: {
    height: '13px !important',
    margin: '0 2px !important',
    width: 'auto !important',
    verticalAlign: 'middle !important',
  },
  coeoFooter: {
    opacity: '0.5 !important',
  },
  coeoFooterWhite: {
    opacity: '0.5 !important',
    color: '#fff !important',
  },
  coeoFooterText: {
    fontSize: '12px !important',
    color: 'black !important',
  },
  linkStyle: {
    fontSize: '13.3333px !important',
    fontFamily: '"Arial" !important',
    textDecoration: 'none !important',
    cursor: 'pointer !important',
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
});

const CoeoFooter = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const lightTheme = theme.palette.mode === 'light';
  const { conferenceState } = useContext(ConferenceContext);

  return (
    conferenceState.conferenceDetail &&
    !conferenceState.conferenceDetail.url_cname && (
      <Box
        align="center"
        pb={2}
        sx={lightTheme ? classes.coeoFooter : classes.coeoFooterWhite}
      >
        <CssBaseline />
        <Typography
          sx={classes.coeoFooterText}
          align="center"
          variant="body1"
          gutterBottom
        >
          Powered by{' '}
          <a target="_blank" rel="noreferrer" href="https://coeo.events">
            <Box
              component="img"
              sx={classes.coeoLogo}
              src={
                lightTheme
                  ? '/images/coeo-logo.svg'
                  : '/images/coeo-logo-white.svg'
              }
            />
          </a>{' '}
          event system
          <br />
          <Link sx={classes.linkStyle} href="mailto:support@coeo.events">
            support@coeo.events
          </Link>
        </Typography>
      </Box>
    )
  );
};

export default CoeoFooter;
